import CryptoJS from 'crypto-js'
// import { JSEncrypt } from 'jsencrypt'

const SECRET_KEY = '9e5702ead4d643fd' // 咪咕上报埋点的
export default {
  encrypt (word) {
    try {
      const key = CryptoJS.enc.Utf8.parse(SECRET_KEY)
      const encrypted = CryptoJS.AES.encrypt(word, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      })
      return encrypted.toString() // 返回Base64格式密文
    } catch (error) {
      console.error('加密失败：', error.message)
      return null
    }
  },

  // aes: function (word, keyStr) {
  //   keyStr = keyStr || 'yLgLkLYMMmWFpcFc'
  //   const key = CryptoJS.enc.Utf8.parse(keyStr)
  //   const srcs = CryptoJS.enc.Utf8.parse(word)
  //   const encrypted = CryptoJS.AES.encrypt(srcs, key, {
  //     mode: CryptoJS.mode.ECB,
  //     padding: CryptoJS.pad.Pkcs7
  //   })
  //   return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
  // },
  // rsa: function (word, keyStr) {
  //   keyStr =
  //     keyStr ||
  //     'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCQktqNf1amHk8C/ba40hZFx36zJbcksY3zICo+DFG2n7sH/mlUsJZUNoHt6hIcorgVTS42Fk6aWUWpvJqnFdtaq//HyIPdwtgW29QQNxA3LjPB4fab4h4JjRCxPOE3kVzTkznRO9AnRGWrXfWLJJJdLFXrNSS6N6Jonee6Q6kRSQIDAQAB'
  //   const encrypt = new JSEncrypt({ log: true })
  //   encrypt.setPublicKey(keyStr)
  //   return encrypt.encrypt(word)
  // },
  // 解密
  decrypt (word, keyStr) {
    keyStr = keyStr || 'HsxXNEyweafpmkCW'
    const key = CryptoJS.enc.Utf8.parse(keyStr)
    const decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
    return CryptoJS.enc.Utf8.stringify(decrypt).toString()
  },
  decrypt1 (word, key) {
    // eslint-disable-next-line no-var, no-redeclare
    var key = CryptoJS.enc.Utf8.parse(key)
    const base64 = CryptoJS.enc.Base64.parse(word)
    const src = CryptoJS.enc.Base64.stringify(base64)
    // 解密模式为CBC，补码方式为PKCS5Padding（也就是PKCS7）
    const decrypt = CryptoJS.AES.decrypt(src, key, {
      iv: key, // 偏移量
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })

    const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
    return decryptedStr.toString()
  },
  base64 (base64) {
    const decrypt = CryptoJS.enc.Base64.parse(base64)
    return decrypt.toString(CryptoJS.enc.Utf8)
  },
  byteBase64 (data) {
    const decodedData = decodeURIComponent(data)
    const decodedBytes = Uint8Array.from(atob(decodedData), (c) => c.charCodeAt(0))
    const decryptedBytes = decodedBytes.map((byte) => byte ^ 5)
    const decryptedString = new TextDecoder().decode(decryptedBytes)
    return decryptedString
  },

  // 数字签名 一键登录所使用的签名
  generateMacSignature (secret, data) {
    const hash = CryptoJS.HmacSHA256(data, secret)
    const byteHMAC = CryptoJS.enc.Base64.stringify(hash)
    return byteHMAC
  }
}
